import { Endpoint } from "@rest-hooks/core";
export const DEFAULT_DESIGN = {
    name: "default",
    id: "default",
    muiTheme: t => t
};
export async function loadTenant(name, loader) {
    let key = name && name.trim().toLowerCase();
    try {
        return (await loader(key)) ?? undefined;
    }
    catch (e) {
        if (process.env.NODE_ENV === "development") {
            throw new Error(`Tenant module missing: ${key}`);
        }
        if (key !== "demo")
            return loadTenant("demo", loader);
    }
    throw new Error(`Tenant module missing: ${key}`);
}
export const loadTenantSettings = new Endpoint(async function ({ tenantName, loader }) {
    const { designs = { DEFAULT_DESIGN_KEY: DEFAULT_DESIGN }, getFormats = () => ({}), getMessages = async () => ({}), locales = [], images = {}, formIcons = [], themeObject, designOverride, settings } = (await loadTenant(tenantName, loader)) ?? {};
    return {
        tenantName,
        designs,
        getFormats,
        getMessages,
        locales,
        images,
        formIcons,
        themeObject,
        designOverride,
        settings
    };
}, {
    key({ tenantName }) {
        return `LOAD tenant ${tenantName}`;
    },
    dataExpiryLength: Infinity
});
//# sourceMappingURL=loadTenantSettings.js.map